import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowRight, Zap } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { syncQuotaFromDB } = useAuth();

  const { transactionId, callsAdded, amount } = location.state || {};

  // Ensure quota is up to date in case the page was refreshed
  useEffect(() => { syncQuotaFromDB(); }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight: "100vh", background: "#0F172A",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, sans-serif", padding: 24,
    }}>
      <style>{`@keyframes pop { 0%{transform:scale(0.7);opacity:0} 70%{transform:scale(1.1)} 100%{transform:scale(1);opacity:1} }`}</style>

      <div style={{
        width: "100%", maxWidth: 420,
        background: "#1E293B",
        border: "1px solid rgba(255,255,255,0.07)",
        borderRadius: 20,
        padding: "40px 32px",
        textAlign: "center",
      }}>
        {/* Animated checkmark */}
        <div style={{
          width: 72, height: 72, borderRadius: "50%",
          background: "rgba(34,197,94,0.12)",
          border: "2px solid rgba(34,197,94,0.3)",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 24px",
          animation: "pop 0.4s cubic-bezier(0.34,1.56,0.64,1) forwards",
        }}>
          <CheckCircle2 size={36} color="#22C55E" />
        </div>

        <div style={{ fontSize: 22, fontWeight: 800, color: "#F1F5F9", marginBottom: 8, letterSpacing: "-0.3px" }}>
          Payment Successful
        </div>
        <div style={{ fontSize: 14, color: "#64748B", lineHeight: 1.6, marginBottom: 28 }}>
          Your account has been credited. Invoice will be emailed to you shortly.
        </div>

        {/* Details */}
        <div style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.06)",
          borderRadius: 12,
          padding: "16px 20px",
          marginBottom: 28,
          textAlign: "left",
        }}>
          {callsAdded && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#94A3B8" }}>
                <Zap size={13} color="#6366F1" />
                API calls added
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#22C55E" }}>
                +{callsAdded.toLocaleString("en-IN")}
              </div>
            </div>
          )}
          {amount && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontSize: 13, color: "#94A3B8" }}>Amount paid</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: "#F1F5F9" }}>
                ₹{Math.round(amount * 1.18).toLocaleString("en-IN")}
              </div>
            </div>
          )}
          {transactionId && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div style={{ fontSize: 13, color: "#94A3B8", flexShrink: 0, marginRight: 12 }}>Transaction ID</div>
              <div style={{ fontSize: 12, color: "#64748B", wordBreak: "break-all", textAlign: "right", fontFamily: "monospace" }}>
                {transactionId}
              </div>
            </div>
          )}
        </div>

        <button
          onClick={() => navigate("/app", { replace: true })}
          style={{
            width: "100%", height: 44, borderRadius: 10,
            background: "#6366F1", border: "none",
            color: "#fff", fontSize: 14, fontWeight: 700,
            cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            boxShadow: "0 2px 12px rgba(99,102,241,0.35)",
          }}
        >
          Go to App <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
}
